<section class="dynamic-form-table-wrapper">

  <div class="top-panel">
    <span class="top-panel titles">{{tableTitle | translate}}</span>
    <span class="row-selection-limit" *ngIf="itemSelection && ((!hideMaxItemSelectionText && maxItemSelection) || minItemSelection)">
      ( <b>Row Selection: </b><span *ngIf="maxItemSelection"> max. {{maxItemSelection}}</span>
      <span *ngIf="minItemSelection"> min. {{minItemSelection}}</span> )
    </span>
    <div *ngIf="isUpperRight()">
      <gen-button class="top-panel add-button" *ngIf="isAddItemsAvailable()"
                  [ngClass]="uniqueButtonName | automationLocator:'BUTTON'"
                  (click)="emitAddItem()"
                  [type]="'emphasis'"
                  [text]="'Add'"
                  [disabled]="disableAddButton"
                  [iconClass]="'icon__plus'">
      </gen-button>
    </div>
  </div>

  <gen-selection-list
    [ngClass]="titleClass"
    [fields]="titles"
    [counter]="false"
    [listRowType]="'content'"
    [edit]="editMode"
    [disabled]="disabled"
    [prioritizeAvailable]="isPrioritizeAvailable()"
    [deleteItemAvailable]="isDeleteItemAvailable()"
    [listModel]="data"
    (listOrderChangedEmit)="orderChanged($event)"
    [trackByField]="prioritizeTrackByField"
    [listName]="itemTitle"
    [emptyMessageDisplay]="_emptyMessageDisplay$ | async"
    [showTitlesIfEmpty]="showTitlesIfEmpty"
    [hideTitles]="hideTitles"
  >

    <ng-template list-item
                 let-item
                 let-index
    >
      <section class="single-row" [ngClass]="itemCustomizeRowClass(item.data)" (click)="emitClickItem(item.data)">
        <div class="dynamic-form-item-selection" *ngIf="isItemSelectionAvailable">
          <gen-toggle-switch
                  *ngIf="maxItemSelection==1; else multiple_row_selection"
                  [disabled]="isItemSelectionDisabled"
                  [active]="item.data[ITEM_SPECIFIC_SELECTION_PROPERTY]"
                  (statusUpdate)="emitItemSelection(item.data, $event)"
          ></gen-toggle-switch>
          <ng-template #multiple_row_selection>
            <p-checkbox
                    [disabled]="isMultipleItemSelectionDisabled(item.data)"
                    [(ngModel)]="item.data[ITEM_SPECIFIC_SELECTION_PROPERTY]"
                    binary="true"
                    (onChange)="emitItemSelection(item.data, $event)">
            </p-checkbox>
          </ng-template>
        </div>
        <div class="dynamic-form-item-actions" *ngIf="hasInlineAction()">
          <gen-button [type]="'quite'" [iconClass]="'fa fa-bars'" [minPadding]="true" class="action-button"
                      *ngIf="isPrioritizeAvailable()"
                      genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Drag to change priority'"></gen-button>
        </div>
        <gen-dynamic-form #row
          class="dynamic-form-table {{applyCssClass}}"
          [ngClass]="itemNgClass(item.data)"
          (formChange)="updateItemValue(item.data, $event.form)"
          [formData]="item.data"
          [formName]="formId"
          [formConfig]="formItems"
          [disabledForced]="disabled"
          [formVertical]="formVertical"
          [formReflects]="formReflects"
          [emitFormChangeEvenIfInvalid] = "emitFormChangeEvenIfInvalid"
          [requiredMessage]="itemRequiredMessage"
          [editMode]="itemEditMode(item.data)"
          [disabled]="itemDeletedOrDisabled(item.data)"
          [overrides]="itemOverrides(item.data)"
          [popupMode]="popupMode"
          [formItemFullWidth]="formItemFullWidth"
          [formHalfWidth]="formHalfWidth"
          [updatedFieldsContext]="getItemUpdateContext(item.data)"
          (validateChange)="validationEvent($event, item.data, item.index)"
          (formInit)="updateItemValue(item.data, $event, true)"
          [listenToDataChange]="listenToDataChange"
          [updateOnBlur]="itemUpdateOnBlur(item.data)"
          [submitted]="itemSubmitted(item.data)"
          [flagDiffFieldsOnUpdate]="flagDiffFieldsOnUpdate"
        ></gen-dynamic-form>

        <div class="dynamic-form-item-actions" *ngIf="hasInlineAction()">
          <gen-button #deleteEvent [type]="'quite'" [iconClass]="'icon__trash'" [minPadding]="true"
                      *ngIf="isDeleteItemAvailable(item.data) &&  ! itemDisabled(item.data)"
                      (click)="emitDeleteItem(item.data)" [tooltip]="('Delete ' + itemTitle)"
                      genTooltip [tooltipShow]="true" [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="('Delete ' + itemTitle)">
          </gen-button>
        </div>
        <div class="dynamic-form-clone-action" *ngIf="isCloneAvailable()">
          <gen-button #cloneEvent id="tableCloneItem" class="add-button"
                      [ngClass]="uniqueButtonName | automationLocator:'BUTTON'"
                      (click)="emitCloneItem(item.data, item.index)"
                      [type]="'emphasis'"
                      [text]="''"
                      [disabled]="itemDeletedOrDisabled(item.data)"
                      genTooltip [tooltipShow]="true" [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="('Clone ' + itemTitle)"
                      [iconClass]="'icon__Clone'"></gen-button>
        </div>
      </section>
    </ng-template>
  </gen-selection-list>

  <div *ngIf="isLowerLeft()" class="top-panel">
    <gen-button  class="top-panel add-button" *ngIf="isAddItemsAvailable()"
                [ngClass]="uniqueButtonName | automationLocator:'BUTTON'"
                (click)="emitAddItem()"
                [type]="'emphasis'"
                [text]="addButtonText"
                [disabled]="disableAddButton"
                [iconClass]="'icon__plus'">
    </gen-button>
  </div>
</section>
